<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-law.svg" can-back-flag="1"></Header>
    </header>

    <!--一覧-->
    <div id="wrapper">
      <div class="content">
        <div class="law-list">
          <ul>
            <li v-for='row in rows' v-bind:key='row.id'>
              <a :href="row.url" target="_blank" rel="noopener"><img :src="row.logo" :alt="row.title"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-law")
    $("body").addClass("page-law-index")
    cmd.adjustStyle()

    this.search()
  },
  methods: {
    ...mapActions('LawModule', {
      'prevAction': 'prevAction',
      'search': 'search'
    }),
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('id')
      this.showDetail(id)
    }
    
  },
  computed: {    
    ...mapGetters('LawModule', {
      'rows': 'getRows',
    })
  },
  components: {
    Header
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/LawList.vue